const STATUS_CONFIG = {
  idle: { color: 'bg-ivory-300/20', label: 'Idle' },
  connecting: { color: 'bg-gold-400 animate-pulse', label: 'Connecting…' },
  connected: { color: 'bg-jade-500', label: 'Live' },
  disconnected: { color: 'bg-crimson-400 animate-pulse', label: 'Disconnected' },
  error: { color: 'bg-crimson-500', label: 'Error' },
}

export default function ConnectionStatus({ status, callConnected }) {
  const resolved = callConnected ? 'connected' : status
  const config = STATUS_CONFIG[resolved] || STATUS_CONFIG.idle

  return (
    <div className="flex items-center gap-1.5">
      <span className={`status-dot ${config.color}`} />
      <span className="text-xs font-mono text-ivory-300/40">{config.label}</span>
    </div>
  )
}
